export default {
  'login.username.title': 'userName',
  'login.password.title': 'password',
  'login.username.placeholder': 'Account: admin',
  'login.password.placeholder': 'password: admin or ant.design',
  'login.message-invalid-credentials':
    'Invalid username or password（admin/ant.design）',
  'login.message-invalid-verification-code': 'Invalid verification code',
  'login.tab-login-credentials': 'Credentials',
  'login.tab-login-mobile': 'Mobile number',
  'login.mobile.placeholder': 'Mobile number',
  'login.mobile.verification-code.placeholder': 'Verification code',
  'login.remember-me': 'Remember me',
  'login.forgot-password': 'Forgot your password?',
  'login.sign-in-with': 'Sign in with',
  'login.signup': 'Sign up',
  'login.login': 'Login',
  'login.generateMenu': 'Generating menu, please wait...',
  'register.register': 'Register',
  'register.email.placeholder': 'Email',
  'register.password.placeholder': 'Password ',
  'register.password.popover-message': 'Please enter at least 6 characters. Please do not use passwords that are easy to guess. ',
  'register.confirm-password.placeholder': 'Confirm password',
  'register.get-verification-code': 'Get code',
  'register.sign-in': 'Already have an account?',
  'register-result.msg': 'Account：registered at {email}',
  'register-result.activation-email':
    'The activation email has been sent to your email address and is valid for 24 hours. Please log in to the email in time and click on the link in the email to activate the account.',
  'register-result.back-home': 'Back to home',
  'register-result.view-mailbox': 'View mailbox',
  'email.required': 'Please enter your email!',
  'email.wrong-format': 'The email address is in the wrong format!',
  'username.required': 'Please enter account name or email address',
  'password.required': 'Please enter your password!',
  'password.twice.msg': 'The passwords entered twice do not match!',
  'password.strength.msg':
    'The password is not strong enough',
  'password.strength.strong': 'Strength: strong',
  'password.strength.medium': 'Strength: medium',
  'password.strength.low': 'Strength: low',
  'password.strength.short': 'Strength: too short',
  'confirm-password.required': 'Please confirm your password!',
  'phone-number.required': 'Please enter your phone number!',
  'phone-number.wrong-format': 'Please enter a valid phone number',
  'verification-code.required': 'Please enter the verification code!'
}
